import React, {useCallback, useContext, useEffect, useState} from "react";
import {HttpStatus, useWait} from "../utils/wait_fn";

import {ModalContext} from "../provider/model_provider";
import styled from "styled-components";
import ReactLoading from "react-loading";
import errorImg from "../assets/imgs/error_warning.png"
import sueccessImg from "../assets/imgs/http_suecess.png"
import feiImg from "../assets/imgs/fei.png"
import {UrlHaxFormat} from "../utils/url";
import {ButtonWidget} from "../widget/pub/pub";


export const LoadingModal: React.FC<{
    data: any,
    status: HttpStatus,
    onDismiss?: any,
    success?: React.FC<any>,
    transfer?: boolean
}> = ({
          data,
          children,
          onDismiss,
          status,
          success,
          transfer
      }) => {

    const [widget, setWidget] = useState<any>(children);

    useEffect(() => {


        if (status === HttpStatus.failure) {
            console.log(data)
            if (data.err.code && data.err.code === 4001) {
                onDismiss()
            }
            setWidget(<LoadingWapStyle><ErrWidget msg={data.err.msg}/></LoadingWapStyle>)
        }
        if (status === HttpStatus.wait) {
            setWidget(<LoadingWapStyle><WaitWidget/></LoadingWapStyle>)
        }
        if (status === HttpStatus.success) {

            if (success) {
                setWidget(React.createElement(success, {onDismiss: onDismiss}, null))
                return
            }
            if (transfer) {
                setWidget(<LoadingWapStyle><TransferWidget hash={data} onDismiss={onDismiss}/></LoadingWapStyle>)
                return;
            }
            setWidget(<LoadingWapStyle><SuccessWidget/></LoadingWapStyle>)
        }


    }, [status])
    return (
        <div>
            {widget}
        </div>
    );
}


export const LoadingWidget: React.FC<{
    confirmationFn: Function,
    onDismiss?: any,
    successWidget?: React.FC<any>
}> = ({
          confirmationFn,
          onDismiss,
          successWidget
      }) => {
    const {request, status, data} = useWait<any>(confirmationFn);
    useEffect(() => {
        request()
    }, [])
    return (
        <LoadingModal onDismiss={onDismiss} success={successWidget} data={data} status={status}/>
    );
}


/**
 * 使用 SendModal 带参数时使用
 * @param confirmationFn
 */
export const useSendModal = (confirmationFn: Function, node?: React.FC) => {
    const {onPresent} = useContext(ModalContext);
    const onWithdraw = useCallback((...res) => {
        onPresent(<LoadingWidget confirmationFn={() => confirmationFn(...res)} successWidget={node}/>);
    }, [])
    return onWithdraw;
}


const WaitWidget: React.FC = () => {
    return (
        <div>
            <div className={'top'}>
                <ReactLoading type={'bars'} color="#fff"/>
            </div>
            <div className={'bottom'}>
                <h2>Waiting For Confirmation</h2>
                <h3>Confirm this transaction in your wallet</h3>
            </div>
        </div>
    );
}


const TransferWidget: React.FC<{ hash: string, onDismiss: any }> = ({hash, onDismiss}) => {
    // const [ onDismiss] = useModel(<div/>);
    return (
        <div>
            <div className={'top'}>
                <img src={feiImg} alt=""/>
            </div>

            <div className={'bottom'}>
                <h2>Transaction Submitted</h2>
                <a href={UrlHaxFormat(hash, 'tx')} target="_blank">View on Etherscan</a>
                <div style={{height: "20px"}}/>
                <ButtonWidget size={{x:8,y:25}} text={'Close'} onClick={onDismiss}/>
            </div>
        </div>
    );
}

const SuccessWidget: React.FC = () => {
    return (
        <div>
            <div className={'top'}>
                <img src={sueccessImg} alt=""/>
            </div>
            <div className={'bottom'}>
                <h2>Waiting For Confirmation</h2>
                <h3>Confirm this transaction in your wallet</h3>
            </div>
        </div>
    );
}

const ErrWidget: React.FC<{ msg: string }> = ({msg}) => {
    return (
        <div>
            <div className={'top'}>
                <img src={errorImg} alt=""/>
                {/*<ReactLoading type={'bars'} color="#fff"/>*/}
            </div>
            <div className={'bottom'}>
                <h2>{msg}</h2>
            </div>
        </div>
    );
}


const LoadingWapStyle = styled.div`
  width: 528px;
  height: 329px;
  padding: 20px;
  box-sizing: border-box;
  background: linear-gradient(270deg, #9AD6FF 0%, #B49EFF 100%);
  box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.11);
  border-radius: 12px;

  > div {
    height: 100%;
    width: 100%;
    background-color: rgba(255, 255, 255, .48);
    border-radius: 6px;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    padding: 10% 0;
    box-sizing: border-box;

    .top {
      display: flex;
      justify-content: center;

      img {
        display: block;
        width: 90px;
      }
    }

    .bottom {
      text-align: center;

      h2 {
        font-size: 22px;
        font-weight: 400;
        color: #333333;
      }

      h3 {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }

      a {
        display: block;
        color: rgba(98, 54, 255, 1);
      }
    }
  }
`



